import React from "react";
import { LAYOUT_TOKENS } from "@ds/tokens/tokens";
import { Button, Result, Typography } from "antd";
import { Sentry } from "../sentry";

const { Text, Paragraph } = Typography;

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtra("componentStack", info.componentStack);
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="Coś poszło nie tak"
          subTitle="Wystąpił nieoczekiwany błąd. Spróbuj odświeżyć stronę."
          extra={[
            <Button key="reload" type="primary" onClick={() => window.location.reload()}>
              Odśwież stronę
            </Button>,
            <Button key="back" onClick={() => { this.setState({ hasError: false, error: null }); window.history.back(); }}>
              Wróć
            </Button>,
          ]}
        >
          {this.state.error && (
            <Paragraph>
              <Text type="secondary" style={{ fontSize: LAYOUT_TOKENS.fontSizeSmall }}>
                {this.state.error.message}
              </Text>
            </Paragraph>
          )}
        </Result>
      );
    }
    return this.props.children;
  }
}
